import { Dispatch, SetStateAction } from 'react'
import { Table, TableBody, TableContainer } from '@mui/material'

import { BodyRow } from './body-row.component'
import { TableHead } from './table-head.component'

import { IScanRespDto } from 'src/types'
import { getUserIdAndRolesFromToken } from 'src/common/utils'

interface IProps {
  data?: IScanRespDto[]
  sort: string
  setSort: Dispatch<SetStateAction<string>>
  isScaner: boolean
  isFirstItemOpen: boolean
}

export const ScansTable = ({ data, sort, setSort, isScaner, isFirstItemOpen }: IProps) => {
  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
  }
  const activeSort = sort.split('-')[0]
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead
            handleSortChange={handleSortChange}
            activeSort={activeSort}
            sortDirection={sortDirection}
            isScaner={isScaner}
          />
          <TableBody>
            {data?.map((row) => (
              <BodyRow
                item={row}
                key={row.id}
                isScaner={isScaner}
                isOpen={isFirstItemOpen && row.id === data?.[0].id}
                userRole={row.account_role_for_user}
                currentUserRoleAndId={getUserIdAndRolesFromToken()}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
